// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"O1-z","displaySixCardTiles":"P1-z"};